var render = function render(){var _vm=this,_c=_vm._self._c;return _c('theme-provider',{staticClass:"h-100",attrs:{"theme":{ ..._vm.theme }}},[_c('pr-global',{staticClass:"h-100",attrs:{"id":"app"}},[_c('aligns'),(_vm.error)?_c('error'):_vm._e(),(_vm.splash)?_c('splash'):_vm._e(),_c('plugins'),_c('platform'),_c('player'),_c('div',{attrs:{"id":"videoplane"}}),_c('background'),_c('worker')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }